/**
 * `/app/calls` — the route. The page is `pages/client/calls/`.
 *
 * A route file is the address and the guard; the page is the screen. Keeping them
 * apart is what lets a page test mount the page over the recorded world without the
 * router's own tree (`test/clientPage.tsx`), and it is why every one of these is
 * four lines.
 */

import { createFileRoute } from '@tanstack/react-router'

import { CallsPage } from '../../pages/client/calls/CallsPage.js'

export const Route = createFileRoute('/app/calls')({
  component: CallsPage,
})
